import { CircularProgress } from '@mui/material';

import BasePreview from '@modules/_shared/components/report-editor/preview/BasePreview';
import { useReportContext } from '@modules/_shared/components/report-editor/ReportEditorContext';

const DesktopPreview = () => {
  const { scrollToPageRef } = useReportContext();

  return (
    <BasePreview
      onScrollToPageAvailable={scrollToPage => {
        scrollToPageRef.current = scrollToPage;
      }}
      renderLoadingIndicator={() => (
        <CircularProgress
          sx={{
            position: 'absolute',
            top: 35,
            right: 85,
            zIndex: 1,
            opacity: 0.4,
          }}
          variant="indeterminate"
          disableShrink
        />
      )}
    />
  );
};

export default DesktopPreview;
